import { render, staticRenderFns } from "./StockPhysical.vue?vue&type=template&id=6138543e"
import script from "./StockPhysical.vue?vue&type=script&lang=js"
export * from "./StockPhysical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports